module.exports = __webpack_public_path__ + "3862219b47b3c3297da50baa38160b5e.svg";